/** Strip markdown asterisks — chat UI renders plain text only. */
export const stripChatAsterisks = (text) => {
  if (!text) return '';
  let out = String(text);
  for (let i = 0; i < 3; i += 1) {
    out = out.replace(/\*\*([^*]+)\*\*/g, '$1');
    out = out.replace(/(?<!\*)\*([^*\n]+)\*(?!\*)/g, '$1');
  }
  out = out.replace(/^\*\s+/gm, '- ');
  return out.replace(/\*/g, '');
};

export const mapApiMessage = (m) => {
  if (m.role === 'system') return null;
  const isBot = m.role === 'assistant' || m.role === 'bot' || m.role === 'ai';
  const generatedTime =
    m.generated_time != null && m.generated_time !== ''
      ? Number(m.generated_time)
      : m.generatedTime != null
        ? Number(m.generatedTime)
        : null;
  return {
    id: m.id,
    role: isBot ? 'ai' : m.role,
    content: stripChatAsterisks(m.content || m.message || ''),
    generatedTime: Number.isFinite(generatedTime) ? generatedTime : null,
    timestamp: m.created_at ? new Date(m.created_at * 1000) : new Date(),
  };
};

/** Ticket rows from an AI response's `sources` (list answers ship rows here). */
export const extractTicketRows = (sources) =>
  Array.isArray(sources)
    ? sources.filter((s) => s && s.type === 'ticket' && (s.ticket_code || s.id))
    : [];
